import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { DynamicRoutingComponent } from './dynamic-routing.component';
@NgModule({
    declarations: [
        DynamicRoutingComponent
    ],
    exports: [
        DynamicRoutingComponent
    ],
    imports: [
        CommonModule,
        RouterModule
    ]
})
export class DynamicRoutingModule { }